import React from 'react';
import packageJson from "../../package.json";
import moment from 'moment';

class ClearCache extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            isLatestVersion: false,
            refreshCacheAndReload: async () => {
                console.log('Clearing cache and hard reloading...');
                if (caches) {
                    const names = await caches.keys();
                    await Promise.all(names.map(name => caches.delete(name)));
                }
                window.location.reload(true);
            }
        };
    }

    componentDidMount() {
        fetch('/meta.json')
            .then((response) => response.json())
            .then((meta) => {
                const latestVersionDate = meta.buildDate;
                const currentVersionDate = packageJson.buildDate;

                const shouldForceRefresh = this.buildDateGreaterThan(latestVersionDate, currentVersionDate);
                if (shouldForceRefresh) {
                    console.log('We have a new version.');
                    this.setState({ loading: false, isLatestVersion: false });
                } else {
                    console.log('You already have the latest version.');
                    this.setState({ loading: false, isLatestVersion: true });
                }
            });
    }

    buildDateGreaterThan = (latestDate, currentDate) => {
        const momLatestDateTime = moment(latestDate);
        const momCurrentDateTime = moment(currentDate);

        if (momLatestDateTime.isAfter(momCurrentDateTime)) {
            return true;
        } else {
            return false;
        }
    };

    render() {
        const { loading, isLatestVersion, refreshCacheAndReload } = this.state;
        return this.props.children({ loading, isLatestVersion, refreshCacheAndReload });
    }
}

export default ClearCache;